import React from 'react';
import { Building2, Clock } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';
export function SocialProofSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 bg-[#EDE7F6]" data-id="element-224" data-mp="1zcu8bx0hid4m">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225" data-mp="1zc1bbnrbv1zo">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-center" data-id="element-226" data-mp="24b43i7m7ldq8">
          <div className="flex flex-col items-center" data-id="element-227" data-mp="1qbw4pftyk7mk">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#7C4DFF] mb-6 shadow-sm" data-id="element-228" data-mp="1qaba5q7n8oop">
              <Building2 size={32} data-id="element-229" data-mp="1ub4wwg9cnxg0" />
            </div>
            <div className="text-6xl font-bold text-[#7C4DFF] mb-2" data-id="element-230" data-mp="1geqcg49lyakr">20+</div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-231" data-mp="1lc9pj0ukkhb4">
              {t('social.gardens')}
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-232" data-mp="3at11acq7d4qj">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#7C4DFF] mb-6 shadow-sm" data-id="element-233" data-mp="3fqkgbeuq5ljj">
              <Clock size={32} data-id="element-234" data-mp="neerz4az8z6s" />
            </div>
            <div className="text-6xl font-bold text-[#7C4DFF] mb-2" data-id="element-235" data-mp="nd3o74hj7rfo">28.8</div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-236" data-mp="iflj5p6mxwcy">
              {t('social.hours')}
            </p>
          </div>
        </div>
      </div>
    </section>;
}